export default "__VITE_PUBLIC_ASSET__b775cf15__"